import { render, staticRenderFns } from "./IconHeadset.vue?vue&type=template&id=c6d3a78e&functional=true&"
import script from "./IconHeadset.vue?vue&type=script&lang=js&"
export * from "./IconHeadset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports